import { PrivacyDocument } from 'app/src/services/welfareportal'
import { PrivacyDocumentUpdateRequest, PrivacyDocumentUploadRequest } from 'app/src/services/welfareportal/membership-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const privacyDocumentStatusSchema: z.ZodType<PrivacyDocument.StatusEnum> = z.enum(PrivacyDocument.StatusEnum)

export const privacyDocumentSchema: z.ZodType<PrivacyDocument> = z.object({
  documentId: z.string(),
  documentName: z.string(),
  status: privacyDocumentStatusSchema,
  urlPath: z.string(),
})

export const privacyDocumentUploadRequestSchema: z.ZodType<PrivacyDocumentUploadRequest> = z.object({
  documentName: z.string().max(255),
  contentType: z.string().max(255),
})

export const privacyDocumentUpdateRequestSchema: z.ZodType<PrivacyDocumentUpdateRequest> = z.object({
  documentName: z.string().max(255),
  documentStatus: z.literal('uploaded'),
})
